import React, {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import {useEthers} from "@usedapp/core";
import styled from "styled-components";
import StackingConnectWalletCard from "./StackingConnectWalletCard";
import InitialCard from "./InitialDeposit";
import MultiFunctionalCard from "./MultiFunctionalCard";
import CardHeader from "./CardHeader";
import CardFooter from "./CardFooter";
import styles from "./card.module.scss";
import {
  getContractUserInfo,
  getTotalAllowance,
  getTotalBalance,
} from "../../store/stakingStore";
function StackingCard({stackingPool}) {
  const dispatch = useDispatch();

  const contractUserInfo = useSelector(
    (state) => state.stakingSlice.contractUserInfo
  );
  // const allStakingPools = useSelector(
  //   (state) => state.stakingSlice.allStakingPools
  // );
  const findItem = contractUserInfo.find(
    (x) => x.id === stackingPool.id && x.isFixed === stackingPool.isFixed
  );

  const {active, account, library} = useEthers();
  useEffect(() => {
    const contractobj = {
      stackingPoolId: stackingPool?.id,
      account,
      isFixed: stackingPool?.isFixed,
    };
    const allowanceObj = {
      account,
    };

    if (account) {
      dispatch(getContractUserInfo(contractobj));
      dispatch(getTotalAllowance({...allowanceObj, provider:library }));
    }
  }, [dispatch, library]);
  useEffect(() => {
    const totalBalanceObj = {
      account,
    };
    dispatch(getTotalBalance({...totalBalanceObj, provider:library }));
  }, [dispatch, library]);

  const [isDeposit, setIsDeposit] = useState(false);

  useEffect(() => {
    if (findItem?.amount.toString() > 0) {
      setIsDeposit(true);
    }
  }, [contractUserInfo, findItem?.amount]);

  return (
    <CardContainer
      className={`${styles.container} ${isDeposit && styles.isDeposit} ${
        findItem?.amount.toString() > 0 && styles.depositContainer
      }`}
    >
      <div className={styles.inlineContainer}>
        <CardHeader
          amount={findItem?.amount.toString()}
          stackingPool={stackingPool}
        />

        {account ? (
          findItem?.amount.toString() > 0 ? (
            <MultiFunctionalCard
              stackingPool={stackingPool}
              stakedAmount={findItem?.amount.toString()}
            />
          ) : (
            <InitialCard
              isDeposit={isDeposit}
              setIsDeposit={setIsDeposit}
              stackingPool={stackingPool}
            />
          )
        ) : (
          <StackingConnectWalletCard stackingPool={stackingPool} />
        )}
        <CardFooter
          findItem={findItem}
          stackingPool={stackingPool}
          stakedAmount={findItem?.amount.toString()}
        />
      </div>
    </CardContainer>
  );
}

const CardContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: rgb(70 9 9) 0px 13px 27px -5px, rgb(0 0 0 / 94%) 0px 8px 16px -8px;
`;

export default StackingCard;
